export default "/images/vendor/flag-icons/flags/1x1/mn.svg?94e1aa063db5c163beeb52a9418c3cc2";